import Phaser from "phaser";
import { COLORS, GAME_WIDTH } from "../config";

const PAD = 14;
const MAX_W = 110; // minimap box width budget (height derived from map aspect)

/**
 * Corner minimap: region outline, the player's position, and enemy density as
 * dots. Cleared areas naturally appear cleaner as enemies are removed. Does NOT
 * show enemy Strength numbers — those stay local to the world view.
 */
export default class Minimap {
  private g: Phaser.GameObjects.Graphics;
  private boxW: number;
  private boxH: number;
  private originX: number;
  private originY: number;
  private scale: number;

  constructor(scene: Phaser.Scene, map: { width: number; height: number }) {
    this.boxW = MAX_W;
    this.boxH = (MAX_W * map.height) / map.width;
    this.scale = this.boxW / map.width;
    // Top-right corner, tucked below the score readout.
    this.originX = GAME_WIDTH - this.boxW - PAD;
    this.originY = 96;

    this.g = scene.add.graphics().setScrollFactor(0).setDepth(92);
  }

  /** Redraw with current enemy positions and the player position (world coords). */
  update(enemies: { x: number; y: number }[], px: number, py: number): void {
    const g = this.g;
    g.clear();

    // Panel + region outline.
    g.fillStyle(0x05080f, 0.55);
    g.fillRoundedRect(this.originX - 4, this.originY - 4, this.boxW + 8, this.boxH + 8, 6);
    g.lineStyle(2, 0x9fd8ff, 0.55);
    g.strokeRoundedRect(this.originX - 4, this.originY - 4, this.boxW + 8, this.boxH + 8, 6);

    // Enemy density dots.
    g.fillStyle(COLORS.enemyRing, 0.85);
    for (const e of enemies) {
      g.fillCircle(this.originX + e.x * this.scale, this.originY + e.y * this.scale, 1.8);
    }

    // Player marker.
    const pxm = this.originX + px * this.scale;
    const pym = this.originY + py * this.scale;
    g.fillStyle(COLORS.gold, 1);
    g.fillCircle(pxm, pym, 3.2);
    g.lineStyle(1.5, 0xffffff, 0.9);
    g.strokeCircle(pxm, pym, 5);
  }

  destroy(): void {
    this.g.destroy();
  }
}
